import React from "react";
import { ScatterChart, Scatter, Cell, XAxis, YAxis, ZAxis, CartesianGrid, Tooltip, ReferenceLine } from "recharts";
import { COLORS, axis, box, Wrap } from "./DashCharts";
import { Empty } from "./BiUi";

const sortClasses = (a, b) => {
  const hierarchy = {
    "Nursery": 1, "LKG": 2, "HKG": 3,
    "1st": 10, "2nd": 20, "3rd": 30, "4th": 40, "5th": 50,
    "6th": 60, "7th": 70, "8th": 80, "9th": 90, "10th": 100,
    "11th": 110, "12th": 120
  };
  const getRank = (name) => {
    if (!name) return 999;
    const key = Object.keys(hierarchy).find(h => name.startsWith(h));
    return key ? hierarchy[key] : 500;
  };
  const rankA = getRank(a);
  const rankB = getRank(b);
  if (rankA !== rankB) return rankA - rankB;
  return String(a).localeCompare(String(b), undefined, { numeric: true });
};

const pairTip = (fmt) => ({ active, payload }) => (active && payload && payload[0] ? (
  <div style={box}><b>{payload[0].payload.name}</b><div className="mt-1 text-slate-500">{fmt(payload[0].payload)}</div></div>
) : null);

/** Attendance % (x) vs exam % (y), paired from marksheet data. */
export function PairScatter({ points }) {
  return (
    <Wrap>
      <ScatterChart margin={{ top: 8, right: 16, left: -10, bottom: 4 }}>
        <CartesianGrid stroke={COLORS.grid} strokeDasharray="3 3" />
        <XAxis type="number" dataKey="attendancePct" name="Attendance" unit="%" domain={[0, 100]} {...axis} />
        <YAxis type="number" dataKey="examPercent" name="Exam score" unit="%" domain={[0, 100]} {...axis} />
        <ZAxis range={[50, 50]} />
        <ReferenceLine x={75} stroke={COLORS.absent} strokeDasharray="4 4" />
        <Tooltip cursor={{ strokeDasharray: "3 3" }} content={pairTip((p) => `Attendance ${p.attendancePct}% | Exam ${p.examPercent}%`)} />
        <Scatter data={points} fill={COLORS.academic} fillOpacity={0.8} />
      </ScatterChart>
    </Wrap>
  );
}

/** Student risk scatter (attendance vs homework). Red = under 75%. */
export function RiskDots({ students, onSelect }) {
  const col = (l) => (l === "critical" ? COLORS.absent : l === "watch" ? COLORS.leave : COLORS.present);
  return (
    <Wrap>
      <ScatterChart margin={{ top: 8, right: 16, left: -10, bottom: 4 }}>
        <CartesianGrid stroke={COLORS.grid} strokeDasharray="3 3" />
        <XAxis type="number" dataKey="attendancePct" name="Attendance" unit="%" domain={[0, 100]} {...axis} />
        <YAxis type="number" dataKey="homeworkPct" name="Homework" unit="%" domain={[0, 100]} {...axis} />
        <ZAxis range={[70, 70]} />
        <ReferenceLine x={75} stroke={COLORS.absent} strokeDasharray="4 4" label={{ value: "75%", fill: COLORS.absent, fontSize: 10, position: "top" }} />
        <Tooltip cursor={{ strokeDasharray: "3 3" }} content={pairTip((p) => `Attendance ${p.attendancePct}% | Homework ${p.homeworkPct}%`)} />
        <Scatter data={students} onClick={(p) => onSelect && onSelect(p)}>
          {students.map((s) => <Cell key={s.studentId} fill={col(s.level)} cursor="pointer" />)}
        </Scatter>
      </ScatterChart>
    </Wrap>
  );
}
